import Cookies from 'js-cookie';

const EXIT_INTENT_COOKIE_NAME = 'exit_intent_shown';
const DISCLAIMER_COOKIE_NAME = 'disclaimer_accepted';

class CookieService {
  /**
   * Generic cookie methods
   */
  static set(name, value, options = {}) {
    return Cookies.set(name, value, options);
  }

  static get(name) {
    return Cookies.get(name);
  }

  static remove(name) {
    return Cookies.remove(name);
  }

  static has(name) {
    return !!Cookies.get(name);
  }

  /**
   * Exit Intent Cookie methods
   */
  static hasExitIntentCookie() {
    return this.has(EXIT_INTENT_COOKIE_NAME);
  }

  static setExitIntentCookie(days = 1) {
    return this.set(EXIT_INTENT_COOKIE_NAME, 'true', { expires: days });
  }

  static setExitIntentLongTermCookie() {
    return this.set(EXIT_INTENT_COOKIE_NAME, 'true', { expires: 365 * 10 });
  }

  static clearExitIntentCookie() {
    return this.remove(EXIT_INTENT_COOKIE_NAME);
  }

  static getExitIntentCookie() {
    return this.get(EXIT_INTENT_COOKIE_NAME);
  }

  /**
   * Disclaimer Cookie methods
   */
  static hasDisclaimerCookie() {
    return this.has(DISCLAIMER_COOKIE_NAME);
  }

  static setDisclaimerCookie(days = 365) {
    return this.set(DISCLAIMER_COOKIE_NAME, 'true', { expires: days });
  }

  static clearDisclaimerCookie() {
    return this.remove(DISCLAIMER_COOKIE_NAME);
  }

  static getDisclaimerCookie() {
    return this.get(DISCLAIMER_COOKIE_NAME);
  }
}

export default CookieService;
